import { Slider } from '@/features/slider/ui/Slider';

export { Slider };
